var  comjs = {
  baseUrl:"https://coupon.17fbfb.com/WebApi/",
  //baseUrl:'http://192.168.1.126:8169/WebApi/',
  //baseUrl:'http://192.168.1.107:8077/WebApi/',
  
  sortAsc :function(o) {
    var n = [];
    for (var k in o) n.push(k);
    n.sort();
    for (var i = 0, str = ''; i < n.length; i++) {
      var v = o[n[i]];
      if (typeof v == 'string') {
        if (n[i].indexOf("TIME") != -1) {
          v=v.replace("T", "")
        }
        v = v.replace(/\s+/g, "")
      }
        
      if (v) {
        if ({}.toString.call(v) == '[object Object]') {
          //v = this.sortAsc(v);
          //v = JSON.stringify(v).replace(/:/g,'=');
          v = JSON.stringify(v)
        }
        else if ({}.toString.call(v) == '[object Array]') {
          //v = JSON.stringify(v).replace(/:/g,'=');
          v = JSON.stringify(v)
        }

      }
      str += n[i] + v;
    }
    //console.log(str)
    return str;
  },
  requestDataEncrypt:function (data, token,sign) {
    var newData = {
      TIMESTAMP: new Date().getTime(),
      TOKEN: token,
      DATA: data,
      DATASIGN: sign,
    }
    return newData
  },
  GetQueryString:function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  PH : document.body.clientHeight,
  PW : document.body.clientWidth,
  getCoordinateByStr(str){
      var arr=[]
      if(str.indexOf("MULTIPOLYGON")!= -1){
        str=str.replace("MULTIPOLYGON(","")
        str= str.substring(0,str.length-1)
        while(str.indexOf("((")!= -1){
          str=str.replace("((","")
        }
        while(str.indexOf(")),")!= -1){
          str=str.replace(")),","|")
        }
        str= str.substring(0,str.length-2)
        var b=str.split("|")
        if(b.length>0){
          for(var j=0;j<b.length;j++){
            var p2=b[j].split(",")
            var dian=[]
            for(var k=0;k<p2.length;k++){
              var  o2=p2[k].split(" ")
              dian.push([parseFloat(o2[0]),parseFloat(o2[1])])
            }
            arr.push(dian)
          }
        }
      }else if(str.indexOf("POLYGON")!= -1){
        str=str.replace("POLYGON((","")
        str= str.substring(0,str.length-2)
        var a=str.split(",")
        if(a.length>0){
          for(var i=0;i<a.length;i++){
            var p1=a[i].split(" ")
            arr.push([parseFloat(p1[0]),parseFloat(p1[1])])
          }
        }
        arr=[arr]
      } 
      return arr
  },
  getAzimuthStr(angle){
    var str=""
    if(angle>0 && angle>360){
      angle=angle-360
    }
    if(angle<0 && angle<-360){
      angle=angle+360
    }
    if(angle==0 || angle==360 || angle==-360){
      str="正北"
    }else if(angle>0 && angle<90){
      str="北偏东"
    }else if(angle==90 || angle==-270){
      str="正东"
    }else if(angle>90 && angle<180){
      str="东偏南"
    }else if(angle==180 || angle==-180){
      str="正南"
    }else if(angle>180 && angle<270){
      str="南偏西"
    }else if(angle==270 || angle==-90){
      str="正西"
    }else if(angle>270 && angle<360){
      str="西偏北"
    }else if(angle<0 && angle> -90){
      str="北偏西"
    }else if(angle<-90 && angle> -180){
      str="西偏南"
    }else if(angle<-180 && angle> -270){
      str="南偏东"
    }else if(angle<-270 && angle> -360){
      str="东偏北"
    }
    return str
  },
  getDateStrByDate(date,type){
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var hour = date.getHours();
    var minutes = date.getMinutes() ;
    var seconds = date.getSeconds();
    var strDate = date.getDate();
    
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }

    if (hour >= 0 && hour <= 9) {
      hour = "0" + hour;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
    }

    var str=""
    if(type=="1"){
      str=year + "-" + month + "-" + strDate
    }else if(type=="2"){
      str=year + "-" + month + "-" + strDate+" "+hour+":" +minutes+":" +seconds
    }
    return str
  },
  compareDate(date1,date2){
    var result = true;
    if(date1.getFullYear() < date2.getFullYear()){
        result = false;
    }else{
      if(date1.getMonth() < date2.getMonth()){
          result = false;
      }else{
        if(date1.getDate() < date2.getDate()){
          result = false;
        }
      } 
    }
    return result;
  },
  toFixedPrice(num){
      var p=2
      let result = parseFloat(num);
      if (isNaN(result)) {
          return false;
      }
      let multiplicator = Math.pow(10, p);
      result = Math.round(num * multiplicator) / multiplicator;
      let s_x = result.toString();
      let pos_decimal = s_x.indexOf('.');
      if (pos_decimal < 0) {
          pos_decimal = s_x.length;
          s_x += '.';
      }
      while (s_x.length <= pos_decimal + p) {
          s_x += '0';
      }
      s_x =parseFloat(s_x)
      s_x =s_x.toFixed(2)
      s_x =parseFloat(s_x)
      return s_x;
  },


}
export default comjs